import View from "./View.js";
const icons = new URL("../../img/icons.svg", import.meta.url);

class addUserRecipeView extends View {
  _parentEle = document.querySelector(".upload");
  _message = "Recipe added Successfully! Thanku :)";

  _window = document.querySelector(".add-recipe-window");
  _overlay = document.querySelector(".overlay");
  _btnOpen = document.querySelector(".nav__btn--add-recipe");
  _btnClose = document.querySelector(".btn--close-modal");

  constructor() {
    super();
    this._addHandlerShowWindow();
    this._addHandlerHideWindow();
  }

  toogleWindow = () => {
    this._window.classList.toggle("hidden");
    this._overlay.classList.toggle("hidden");
  };

  _addHandlerShowWindow() {
    this._btnOpen.addEventListener("click", this.toogleWindow.bind(this));
  }
  _addHandlerHideWindow() {
    this._btnClose.addEventListener("click", this.toogleWindow.bind(this));
    this._overlay.addEventListener("click", this.toogleWindow.bind(this));
  }

  addHandlerAddRecipe(handler) {
    this._parentEle.addEventListener("submit", function (e) {
      e.preventDefault();
      const dataArr = [...new FormData(this)];
      const data = Object.fromEntries(dataArr);
      handler(data);
    });
  }
  _generateMarkup = () => {};
}
export default new addUserRecipeView();
